<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" dark class="header-title">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("_UserGroupDetail")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="12">
              <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="12" md="5" class="pa-2">
                    <v-text-field
                      id="username-field-search-usergroupdetail"
                      :label="$t('username')"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-text-box-search-outline"
                      hide-details
                      clearable
                      v-model="username"
                      @keydown.enter="Search"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" class="pa-2">
                    <v-text-field
                      id="email-field-search-usergroupdetail"
                      :label="$t('email')"
                      v-model="email"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-email-outline"
                      hide-details
                      clearable
                      @keydown.enter="Search"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    class="pa-2 d-flex align-center justify-end"
                  >
                    <v-btn
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      @click="Search"
                    >
                      <v-icon start>mdi-magnify</v-icon>
                      Search
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="12" class="d-flex flex-wrap justify-end gap-2">
              <div class="action-controls">
                <!-- Sync Button -->
                <v-btn
                  id="button-sync-usergroupdetail"
                  color="info"
                  class="control-btn sync-btn"
                  variant="text"
                  size="small"
                  density="comfortable"
                  prepend-icon="mdi-sync"
                  @click="Sync"
                  v-if="!StatusSync"
                >
                  <span class="btn-text">{{ $t("sync") }}</span>
                  <v-tooltip activator="parent" location="top">
                    Sync Users
                  </v-tooltip>
                </v-btn>

                <!-- Sync Loading Button -->
                <v-btn
                  id="button-sync-loading-usergroupdetail"
                  color="info"
                  class="control-btn sync-btn"
                  variant="text"
                  size="small"
                  density="comfortable"
                  disabled
                  v-else
                >
                  <v-icon start class="mdi-spin">mdi-sync</v-icon>
                  <span class="btn-text">{{ $t("sync") }}</span>
                  <v-tooltip activator="parent" location="top">
                    Syncing...
                  </v-tooltip>
                </v-btn>

                <!-- Divider -->
                <v-divider
                  vertical
                  thickness="1"
                  length="50"
                  class="mx-4"
                ></v-divider>

                <!-- Setup Button -->
                <v-btn
                  id="button-setup-usergroupdetail"
                  color="primary"
                  class="control-btn setup-btn"
                  variant="elevated"
                  size="large"
                  prepend-icon="mdi-cog"
                  rounded="xl"
                  router
                  :to="'SetupUserGroup?id=' + groupID"
                >
                  <span class="btn-text">{{ $t("setup") }}</span>
                  <v-tooltip activator="parent" location="top">
                    Setup User Group
                  </v-tooltip>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-data-table-server
          :items="filteredUsers"
          :items-per-page="itemsPerPage"
          :items-length="searchTotalTable"
          :loading="loadingTable"
          v-model:options="options"
          :headers="headers"
          class="modern-data-table"
          :hover="true"
          fixed-header
        >
          <!-- No Data Template -->
          <template v-slot:no-data>
            <div class="no-data-container">
              <div class="no-data-content">
                <!-- Icon -->
                <v-icon size="64" color="grey-lighten-2" class="no-data-icon">
                  mdi-account-group-outline
                </v-icon>

                <!-- Message -->
                <div class="no-data-text">
                  <h3 class="no-data-title">Data not available</h3>
                  <p class="no-data-subtitle">No users found in this group</p>
                </div>

                <!-- Action Button -->
                <!-- <v-btn
                  color="primary"
                  variant="outlined"
                  size="default"
                  class="no-data-btn"
                  router
                  :to="'SetupUserGroup?id=' + groupID"
                >
                  <v-icon class="mr-2">mdi-plus</v-icon>
                  Add Users
                </v-btn> -->
              </div>
            </div>
          </template>

          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: center">{{ item.number }}</td>
              <td>{{ item.username }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.mobile }}</td>
              <td>{{ item.fullName }}</td>
              <td style="text-align: center">
                <div class="action-group" style="justify-content: center">
                  <!-- Edit -->
                  <v-btn
                    id="edit-usergroupdetail"
                    variant="text"
                    density="comfortable"
                    :disabled="StatusSync"
                    @click="EditUser(item)"
                    class="action-btn edit-btn"
                    icon
                  >
                    <v-icon size="18">mdi-pencil-outline</v-icon>
                    <v-tooltip activator="parent" location="top">
                      Edit
                    </v-tooltip>
                  </v-btn>
                  <!-- Custom Divider -->
                  <div class="action-divider"></div>

                  <!-- Delete -->
                  <v-btn
                    id="delete-usergroupdetail"
                    variant="text"
                    density="comfortable"
                    :disabled="StatusSync"
                    @click="DeleteUser(item)"
                    class="action-btn delete-btn"
                    icon
                  >
                    <v-icon size="18">mdi-delete-outline</v-icon>
                    <v-tooltip activator="parent" location="top">
                      Delete
                    </v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>
    <!-- EditUserDialog -->
    <v-dialog
      v-model="Editdialog"
      max-width="800px"
      persistent
      class="modern-dialog"
    >
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-edit">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background renew-mode">
                <v-icon size="28" color="white"
                  >mdi-account-edit-outline</v-icon
                >
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title">Change Password</h2>
              <p class="dialog-subtitle">
                Create a new secure password for your account
              </p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
              icon
              variant="text"
              color="white"
              @click="Editdialog = false"
              class="close-button"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="edit-user-content">
          <v-container fluid>
            <!-- Basic Information Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2"
                  >mdi-account-outline</v-icon
                >
                Basic Information
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <v-text-field
                      disabled
                      :label="$t('username')"
                      :rules="[rules.required]"
                      v-model="edit.username"
                      variant="outlined"
                      density="comfortable"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-icon
                          class="help-icon"
                          size="small"
                          @click="showUsernameTooltip = !showUsernameTooltip"
                        >
                          mdi-help-circle-outline
                        </v-icon>
                        <v-tooltip
                          v-model="showUsernameTooltip"
                          activator="parent"
                          location="top"
                        >
                          {{ $t("username") }}
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <!-- Empty space for layout balance -->
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <v-text-field
                      id="firstname-edit-usergroupdetail"
                      :label="$t('firstname')"
                      :rules="[rules.required]"
                      v-model="edit.firstname"
                      variant="outlined"
                      density="comfortable"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-icon
                          class="help-icon"
                          size="small"
                          @click="showFirstnameTooltip = !showFirstnameTooltip"
                        >
                          mdi-help-circle-outline
                        </v-icon>
                        <v-tooltip
                          v-model="showFirstnameTooltip"
                          activator="parent"
                          location="top"
                        >
                          {{ $t("firstname") }}
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <v-text-field
                      id="lastname-edit-usergroupdetail"
                      :label="$t('lastname')"
                      :rules="[rules.required]"
                      v-model="edit.lastname"
                      variant="outlined"
                      density="comfortable"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-icon
                          class="help-icon"
                          size="small"
                          @click="showLastnameTooltip = !showLastnameTooltip"
                        >
                          mdi-help-circle-outline
                        </v-icon>
                        <v-tooltip
                          v-model="showLastnameTooltip"
                          activator="parent"
                          location="top"
                        >
                          {{ $t("lastname") }}
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <v-text-field
                      disabled
                      :label="$t('email')"
                      :rules="[rules.required, validateEmail(edit.email)]"
                      v-model="edit.email"
                      variant="outlined"
                      density="comfortable"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-icon
                          class="help-icon"
                          size="small"
                          @click="showEmailTooltip = !showEmailTooltip"
                        >
                          mdi-help-circle-outline
                        </v-icon>
                        <v-tooltip
                          v-model="showEmailTooltip"
                          activator="parent"
                          location="top"
                        >
                          {{ $t("email") }}
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <v-text-field
                      id="phonenumber-edit-usergroupdetail"
                      :label="$t('phonenumber')"
                      v-model="edit.phone"
                      v-mask="mask"
                      variant="outlined"
                      density="comfortable"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-icon
                          class="help-icon"
                          size="small"
                          @click="showPhoneTooltip = !showPhoneTooltip"
                        >
                          mdi-help-circle-outline
                        </v-icon>
                        <v-tooltip
                          v-model="showPhoneTooltip"
                          activator="parent"
                          location="top"
                        >
                          {{ $t("phonenumber") }}
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="section-divider"></v-divider>

            <!-- Integration Social Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2"
                  >mdi-share-variant-outline</v-icon
                >
                Integration Social
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <v-text-field
                      id="lineuserid-edit-usergroupdetail"
                      ref="socialUserID"
                      :label="$t('SocialUserID')"
                      v-model="edit.socialUserID"
                      variant="outlined"
                      density="comfortable"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <LineIcon
                          :size="18"
                          :opacity="0.7"
                          color="rgb(var(--v-theme-primary))"
                        />
                      </template>
                      <template v-slot:append-inner>
                        <v-icon
                          class="help-icon"
                          size="small"
                          @click="
                            showSocialUserIDTooltip = !showSocialUserIDTooltip
                          "
                        >
                          mdi-help-circle-outline
                        </v-icon>
                        <v-tooltip
                          v-model="showSocialUserIDTooltip"
                          activator="parent"
                          location="top"
                        >
                          {{ $t("SocialUserID") }}
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <v-text-field
                      id="facebookuserid-edit-usergroupdetail"
                      ref="recipientID"
                      :label="$t('RecipientId')"
                      v-model="edit.recipientID"
                      variant="outlined"
                      density="comfortable"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-facebook</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-icon
                          class="help-icon"
                          size="small"
                          @click="
                            showRecipientIDTooltip = !showRecipientIDTooltip
                          "
                        >
                          mdi-help-circle-outline
                        </v-icon>
                        <v-tooltip
                          v-model="showRecipientIDTooltip"
                          activator="parent"
                          location="top"
                        >
                          {{ $t("RecipientId") }}
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <v-text-field
                      id="instagramuserid-edit-usergroupdetail"
                      ref="recipientId_Instagram"
                      :label="$t('RecipientId_Instagram')"
                      v-model="edit.recipientId_Instagram"
                      variant="outlined"
                      density="comfortable"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-instagram</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-icon
                          class="help-icon"
                          size="small"
                          @click="
                            showRecipientInstagramTooltip =
                              !showRecipientInstagramTooltip
                          "
                        >
                          mdi-help-circle-outline
                        </v-icon>
                        <v-tooltip
                          v-model="showRecipientInstagramTooltip"
                          activator="parent"
                          location="top"
                        >
                          {{ $t("RecipientId_Instagram") }}
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="section-divider"></v-divider>

            <!-- Model Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2">mdi-robot-outline</v-icon>
                Model Configuration
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <v-autocomplete
                      id="modelgrouping-edit-usergroupdetail"
                      ref="groupModel"
                      label="Model Grouping"
                      :search-input.sync="searchGroupModel"
                      :items="listDDGroupModel"
                      item-title="name"
                      item-value="id"
                      clearable
                      variant="outlined"
                      density="comfortable"
                      v-model="edit.groupModel"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-icon
                          class="help-icon"
                          size="small"
                          @click="
                            showGroupModelTooltip = !showGroupModelTooltip
                          "
                        >
                          mdi-help-circle-outline
                        </v-icon>
                        <v-tooltip
                          v-model="showGroupModelTooltip"
                          activator="parent"
                          location="top"
                        >
                          {{ $t("_InfoSelectGroupModel") }}
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <v-autocomplete
                      id="model-edit-usergroupdetail"
                      ref="model"
                      label="Model"
                      :items="listDDModel"
                      chips
                      closable-chips
                      item-title="name"
                      item-value="modelDisplayID"
                      multiple
                      clearable
                      variant="outlined"
                      density="comfortable"
                      v-model="edit.model"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-icon
                          class="help-icon"
                          size="small"
                          @click="showModelTooltip = !showModelTooltip"
                        >
                          mdi-help-circle-outline
                        </v-icon>
                        <v-tooltip
                          v-model="showModelTooltip"
                          activator="parent"
                          location="top"
                        >
                          {{ $t("_InfoSelectModel") }}
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <v-autocomplete
                      id="modelshortcut-edit-usergroupdetail"
                      ref="modelQuickGroupID"
                      label="Model Shortcut"
                      :items="DDQuickModel" 
                      item-title="name"
                      item-value="id"
                      clearable
                      variant="outlined"
                      density="comfortable"
                      v-model="edit.modelQuickGroupID"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-icon
                          class="help-icon"
                          size="small"
                          @click="
                            showQuickModelTooltip = !showQuickModelTooltip
                          "
                        >
                          mdi-help-circle-outline
                        </v-icon>
                        <v-tooltip
                          v-model="showQuickModelTooltip"
                          activator="parent"
                          location="top"
                        >
                          {{ $t("_InfoSelectQuickModel") }}
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <div class="actions-content">
            <div class="actions-left">
              <v-btn
                id="button-changepassword-popupedit-usergroupdetail"
                variant="outlined"
                color="blue"
                @click="
                  changePasswordDialog = true;
                  edit.password = null;
                  edit.confirmpassword = null;
                  checkLengthPassword = true;
                  checkLowercaseLetter = true;
                  checkUppercaseLetter = true;
                  checkNumber = true;
                  checkSpecialCharacter = true;
                  checkPasswordMatch = true;
                "
                class="dialog-action-btn change-password-btn"
              >
                <v-icon start>mdi-lock-reset</v-icon>
                Change Password
              </v-btn>
            </div>
            <div class="actions-right">
              <v-btn
                variant="outlined"
                color="grey"
                @click="Editdialog = false"
                class="dialog-action-btn cancel-btn"
              >
                <v-icon start>mdi-close</v-icon>
                {{ $t("close") }}
              </v-btn>
              <v-btn
                id="save-edit-usergroupdetail"
                variant="elevated"
                @click="UpdateUser"
                class="dialog-action-btn save-btn-edit"
              >
                <v-icon start>mdi-content-save</v-icon>
                {{ $t("save") }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Loading Please Wait -->
    <!-- <v-overlay v-model="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear
              indeterminate
              color="#FAA91B"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay> -->
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <!--dialog change password-->
    <v-dialog
      v-model="changePasswordDialog"
      max-width="600px"
      persistent
      class="modern-dialog"
    >
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-change-password">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background renew-mode">
                <v-icon size="28" color="white">mdi-lock-reset</v-icon>
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title">Change Password</h2>
              <p class="dialog-subtitle">
                Create a new secure password for your account
              </p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
              icon
              variant="text"
              size="small"
              @click="closeChangePassword"
              class="close-button"
              color="white"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <!-- <div class="header-content">
            <div class="header-left">
              <div class="header-icon icon-background">
                <v-icon size="28" color="white">mdi-lock-reset</v-icon>
              </div>
              <div class="header-text">
                <h2 class="dialog-title">Change Password</h2>
                <p class="dialog-subtitle">
                  Create a new secure password for your account
                </p>
              </div>
            </div>
            <div class="header-right">
              <v-btn
                icon
                variant="text"
                size="small"
                @click="closeChangePassword"
                class="close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div> -->
        </div>

        <v-divider></v-divider>

        <v-card-text class="change-password-content">
          <v-container fluid>
            <!-- Password Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2">mdi-lock-outline</v-icon>
                Password Requirements
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="input-label">New Password</div>
                    <v-text-field
                      ref="password"
                      :label="$t('password')"
                      :rules="[rules.required]"
                      v-model="edit.password"
                      variant="outlined"
                      density="comfortable"
                      hide-details
                      :append-inner-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show1 ? 'text' : 'password'"
                      @click:append-inner="show1 = !show1"
                      class="modern-input"
                      :style="
                        checkLengthPassword == true &&
                        checkLowercaseLetter == true &&
                        checkUppercaseLetter == true &&
                        checkNumber == true &&
                        checkSpecialCharacter == true
                          ? 'margin-bottom: 26px;'
                          : ''
                      "
                    >
                      <template v-slot:append-outer>
                        <v-icon
                          class="help-icon"
                          size="small"
                          @click="showPasswordTooltip = !showPasswordTooltip"
                        >
                          mdi-help-circle-outline
                        </v-icon>
                        <v-tooltip
                          v-model="showPasswordTooltip"
                          activator="parent"
                          location="top"
                        >
                          {{ $t("password") }}
                        </v-tooltip>
                      </template>
                    </v-text-field>

                    <!-- Password Requirements -->
                    <transition name="expand-fade" mode="out-in">
                      <div
                        class="password-requirements"
                        v-if="edit.password"
                        key="requirements"
                      >
                        <div
                          class="requirement-item"
                          :class="{ valid: checkLengthPassword }"
                        >
                          <v-icon
                            size="14"
                            :color="checkLengthPassword ? 'success' : 'error'"
                          >
                            {{
                              checkLengthPassword ? "mdi-check" : "mdi-close"
                            }}
                          </v-icon>
                          {{ $t("checklengthcharacters") }}
                        </div>
                        <div
                          class="requirement-item"
                          :class="{ valid: checkLowercaseLetter }"
                        >
                          <v-icon
                            size="14"
                            :color="checkLowercaseLetter ? 'success' : 'error'"
                          >
                            {{
                              checkLowercaseLetter ? "mdi-check" : "mdi-close"
                            }}
                          </v-icon>
                          {{ $t("checklowercaseletter") }}
                        </div>
                        <div
                          class="requirement-item"
                          :class="{ valid: checkUppercaseLetter }"
                        >
                          <v-icon
                            size="14"
                            :color="checkUppercaseLetter ? 'success' : 'error'"
                          >
                            {{
                              checkUppercaseLetter ? "mdi-check" : "mdi-close"
                            }}
                          </v-icon>
                          {{ $t("checkuppercaseletter") }}
                        </div>
                        <div
                          class="requirement-item"
                          :class="{ valid: checkNumber }"
                        >
                          <v-icon
                            size="14"
                            :color="checkNumber ? 'success' : 'error'"
                          >
                            {{ checkNumber ? "mdi-check" : "mdi-close" }}
                          </v-icon>
                          {{ $t("checknumber") }}
                        </div>
                        <div
                          class="requirement-item"
                          :class="{ valid: checkSpecialCharacter }"
                        >
                          <v-icon
                            size="14"
                            :color="checkSpecialCharacter ? 'success' : 'error'"
                          >
                            {{
                              checkSpecialCharacter ? "mdi-check" : "mdi-close"
                            }}
                          </v-icon>
                          {{ $t("checkspecialcharacter") }}
                        </div>
                      </div>
                    </transition>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="input-label">Confirm Password</div>
                    <v-text-field
                      ref="confirmpassword"
                      :label="$t('confirmpassword')"
                      :rules="[rules.required]"
                      v-model="edit.confirmpassword"
                      variant="outlined"
                      density="comfortable"
                      hide-details
                      :append-inner-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show2 ? 'text' : 'password'"
                      @click:append-inner="show2 = !show2"
                      class="modern-input"
                      :style="
                        checkPasswordMatch == true ? 'margin-bottom: 26px;' : ''
                      "
                    >
                      <template v-slot:append-outer>
                        <v-icon
                          class="help-icon"
                          size="small"
                          @click="
                            showConfirmPasswordTooltip =
                              !showConfirmPasswordTooltip
                          "
                        >
                          mdi-help-circle-outline
                        </v-icon>
                        <v-tooltip
                          v-model="showConfirmPasswordTooltip"
                          activator="parent"
                          location="top"
                        >
                          {{ $t("confirmpassword") }}
                        </v-tooltip>
                      </template>
                    </v-text-field>

                    <!-- Password Match -->
                    <transition name="expand-fade" mode="out-in">
                      <div
                        class="password-match"
                        v-if="edit.confirmpassword"
                        key="match"
                      >
                        <div
                          class="requirement-item"
                          :class="{ valid: checkPasswordMatch }"
                        >
                          <v-icon
                            size="14"
                            :color="checkPasswordMatch ? 'success' : 'error'"
                          >
                            {{ checkPasswordMatch ? "mdi-check" : "mdi-close" }}
                          </v-icon>
                          {{ $t("checkpasswordmatch") }}
                        </div>
                      </div>
                    </transition>
                  </div>
                </v-col>
              </v-row>
            </div>

            <!-- Security Tips -->
            <div class="security-tips">
              <v-alert
                type="info"
                variant="tonal"
                density="compact"
                class="security-alert"
              >
                <template v-slot:prepend>
                  <v-icon>mdi-shield-check-outline</v-icon>
                </template>
                <div class="alert-content">
                  <strong>Security Tips:</strong>
                  <ul class="tips-list">
                    <li>Use a combination of letters, numbers, and symbols</li>
                    <li>Avoid using personal information in passwords</li>
                    <li>Don't reuse passwords from other accounts</li>
                    <li>Consider using a password manager</li>
                  </ul>
                </div>
              </v-alert>
            </div>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="change-password-actions">
          <v-spacer></v-spacer>
          <v-btn
            variant="outlined"
            color="grey"
            @click="closeChangePassword"
            class="dialog-action-btn cancel-btn"
          >
            <v-icon start>mdi-close</v-icon>
            {{ $t("close") }}
          </v-btn>
          <v-btn
            id="button-savechangepassword-popupedit-usergroupdetail"
            variant="elevated"
            color="primary"
            @click="saveChangePassword"
            :disabled="!passwordIsValid"
            class="dialog-action-btn save-btn-change-password"
          >
            <v-icon start>mdi-content-save</v-icon>
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import store from "../store";
import LogTrace from "@/api/function.js";
import { mask } from "vue-the-mask";
import LineIcon from "@/components/icons/LineIcon.vue";
// import DragDropFile from '@/components/DragDropFile.vue';
export default {
  name: "UserManagement",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  components: { LineIcon },
  mixins: [LogTrace],
  directives: {
    mask,
  },
  data: () => ({
    mask: "##########",
    show1: false,
    formHasErrors: false,
    permission: {
      add: true,
      edit: true,
      delete: true,
    },
    mailcheck: false,
    phonecheck: false,
    filters: {
      username: [],
      email: [],
      employeeName: [],
      userType: [],
    },
    DDRole: [
      {
        name: "Admin",
        value: 1,
      },
      {
        name: "ผู้ใช้งานทั่วไป",
        value: 2,
      },
    ],
    numberRules: [(v) => !!v || "Input is required!"],
    rules: {
      required: (value) => value === null || !!value || "Required.",
      min: (v) => v.length >= 10 || "Min 10 numbers",
    },
    Email: null,
    gg: null,
    UserType: null,
    dialog: false,
    edit: {
      id: null,
      username: null,
      firstname: null,
      lastname: null,
      email: null,
      phone: null,
      password: null,
      confirmpassword: null,
      roleId: null,
      userType: null,
      model: [],
      // recipientId: null,
    },
    user: {
      id: null,
      username: null,
      firstname: null,
      lastname: null,
      email: null,
      phone: null,
      password: null,
      roleId: 2,
      userType: null,
      model: [],
    },
    listDDModel: [],

    oldPassword: "",
    Editdialog: false,
    isSearch: false,
    username: "",
    email: "",
    totalTable: 0,
    itemsPerPage: 10,
    options: {},
    today: null,
    userList: [],
    headers: [],
    secretKey: "01234567890123456789012345678901",
    roleId: Cookies.get("roleId"),
    isFirst: true,
    searchTotalTable: 0,
    sortBy: [],
    sortDesc: [],
    fileImportUser: null,
    flagTemplate: false,
    groupID: null,
    listDDGroupModel: null,
    DDQuickModel: null,
    searchGroupModel: null,
    StatusSync: false,
    loadingTable: false,

    changePasswordDialog: false,
    checkLengthPassword: true,
    checkLowercaseLetter: true,
    checkUppercaseLetter: true,
    checkNumber: true,
    checkSpecialCharacter: true,
    checkPasswordMatch: true,
    statusFormatPassword: false,
    statusPassword: false,
    show2: false,
    showUsernameTooltip: false,
    showFirstnameTooltip: false,
    showLastnameTooltip: false,
    showEmailTooltip: false,
    showPhoneTooltip: false,
    showSocialUserIDTooltip: false,
    showRecipientIDTooltip: false,
    showRecipientInstagramTooltip: false,
    showGroupModelTooltip: false,
    showModelTooltip: false,
    showQuickModelTooltip: false,
    showPasswordTooltip: false,
    showConfirmPasswordTooltip: false,
  }),
  watch: {
    options: {
      handler() {
        if (!this.isInitialized) return;
        this.Get();
      },
      deep: true,
    },
    searchGroupModel(val) {
      this.GetGroupModel(val);
    },
    "edit.password"() {
      let self = this;
      if (
        self.edit.password != null &&
        self.edit.password != undefined &&
        self.edit.password != ""
      ) {
        self.checkLengthPassword = self.edit.password.length >= 8;
        self.checkLowercaseLetter = /[a-z]/.test(self.edit.password);
        self.checkUppercaseLetter = /[A-Z]/.test(self.edit.password);
        self.checkNumber = /\d/.test(self.edit.password);
        // self.checkSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(self.edit.password);
        self.checkSpecialCharacter = /[^a-zA-Z0-9ก-๙]/.test(self.edit.password);
        if (
          self.checkLengthPassword == true &&
          self.checkLowercaseLetter == true &&
          self.checkUppercaseLetter == true &&
          self.checkNumber == true &&
          self.checkSpecialCharacter == true
        ) {
          self.statusFormatPassword = true;
        } else {
          self.statusFormatPassword = false;
        }
        if (self.edit.password == self.edit.confirmpassword) {
          self.checkPasswordMatch = true;
        } else if (
          self.edit.confirmpassword != null &&
          self.edit.confirmpassword.length > 0
        ) {
          self.checkPasswordMatch = false;
        }
      }
    },
    "edit.confirmpassword"() {
      let self = this;
      self.checkPasswordMatch = self.edit.password == self.edit.confirmpassword;
      if (
        self.edit.password != null &&
        self.edit.confirmpassword != null &&
        self.edit.password == self.edit.confirmpassword &&
        self.checkLengthPassword == true &&
        self.checkLowercaseLetter == true &&
        self.checkUppercaseLetter == true &&
        self.checkNumber == true &&
        self.checkSpecialCharacter == true
      ) {
        self.statusPassword = true;
      } else {
        self.statusPassword = false;
      }
    },
  },
  mounted() {
    // this.permission = this.checkPermissionFour(1, 2, 3, 4);
    this.loadingTable = true;
    this.dialog = true;
    this.groupID = this.$route.query.id;
    store.state.groupSecurityID = this.$route.query.id;
    if (
      this.groupID != null &&
      this.groupID != undefined &&
      this.groupID != ""
    ) {
      this.headers = [
        {
          title: this.$t("no"),
          align: "center",
          sortable: false,
        },
        {
          title: this.$t("username"),
          align: "center",
          sortable: true,
          value: "username",
        },
        {
          title: this.$t("email"),
          align: "center",
          sortable: true,
          value: "email",
        },
        {
          title: this.$t("phonenumber"),
          align: "center",
          sortable: true,
          value: "mobile",
        },
        {
          title: this.$t("fullName"),
          align: "center",
          sortable: true,
          value: "fullName",
        },
        {
          title: this.$t("action"),
          align: "center",
          sortable: false,
          width: "150px",
        },
      ];
      Promise.all([
        this.GetDate(),
        this.GetGroupModel(),
        this.GetModel(),
        this.GetDDModelQuickGroup(),
      ]).then(() => {
        this.dialog = false;
        this.Get();
        this.isInitialized = true;
      });
    } else {
      this.$router.push({
        name: "GroupUserManagement",
      });
    }
  },
  computed: {
    passwordIsValid() {
      return (
        this.checkLengthPassword &&
        this.checkLowercaseLetter &&
        this.checkUppercaseLetter &&
        this.checkNumber &&
        this.checkSpecialCharacter &&
        this.checkPasswordMatch &&
        this.edit.password &&
        this.edit.confirmpassword
      );
    },
    filteredUsers() {
      return this.userList.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
    form() {
      return {
        username: this.user.username,
        firstname: this.user.firstname,
        lastname: this.user.lastname,
        email: this.user.email,
        phone: this.user.phone,
        password: this.user.password,
      };
    },
    headersTemplate() {
      return [
        { text: "CSV", align: "center" },
        { text: "Excel", align: "center" },
      ];
    },
  },

  methods: {
    GetGroupModel() {
      let self = this;
      self.$call.GetDDGroupModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDGroupModel = dataResponse.data;
          } else {
            self.listDDGroupModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    GetDDModelQuickGroup() {
      let self = this;
      self.$call.GetDDModelQuickGroup(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDQuickModel = dataResponse.data;
          } else {
            self.DDQuickModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    Sync() {
      let self = this;
      self.dialog = true;
      self.$call.SyncDataEntraIDGroup(
        self.groupID,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal
              .fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              })
              .then(() => {
                self.Get();
              });
          } else {
            self.$swal.fire({
              icon: "warning",
              title: dataResponse.data,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Close",
            });
          }
          self.dialog = false;
        },
        (err) => {
          console.log(err);
          self.dialog = false;
        }
      );
    },

    ConfirmProcess() {
      let self = this;
      self.$swal
        .fire({
          icon: "warning",
          title: this.$t("importUserTitle"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.ImportUser();
          }
        });
    },

    PhoneNumberValidation(phno) {
      let phoneno = /^\d{10}$/;
      return phoneno.test(phno) || "Invalid Phone format";
    },

    validateEmail(email) {
      // eslint-disable-next-line no-useless-escape
      let re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return re.test(email) || "invalid email";
    },
    Search() {
      let self = this;
      self.isSearch = true;
      self.options.page = 1;
      self.Get();
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },

    GetModel() {
      let self = this;
      self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDModel = dataResponse.data;
          } else {
            self.listDDModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    Get() {
      try {
        let self = this;
        // self.dialog = true;
        self.loadingTable = true;

        let { page, itemsPerPage, sortBy } = self.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === "desc";
        }
        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage,
          username: self.username,
          eMail: self.email,
          sortDesc: sortOrder,
          sortBy: sortField,
          groupID: self.groupID,
        };
        self.$call.GetTableUserGroupManagement(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.searchTotalTable = dataResponse.data.total;
              self.userList = dataResponse.data.data;
              self.totalTable = self.isFirst
                ? dataResponse.data.total
                : self.totalTable;
              self.AutoRefresh();
            } else {
              self.userList = [];
              self.totalTable = 0;
              self.searchTotalTable = 0;
            }
            // self.dialog = false;
            self.loadingTable = false;
            self.isSearch = false;
            self.isFirst = false;
          },
          (errorResource) => {
            // self.dialog = false;
            self.loadingTable = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },
    ReFreshGet() {
      try {
        let self = this;
        self.dialog = true;
        self.loadingTable = true;
        const { page, itemsPerPage } = this.options;
        self.sortBy =
          self.options.sortBy.length == 0 ? null : self.options.sortBy[0];
        self.sortDesc =
          self.options.sortDesc.length == 0 ? null : self.options.sortDesc[0];
        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          username: self.username,
          eMail: self.email,
          sortDesc: self.sortDesc,
          sortBy: self.sortBy,
          groupID: self.groupID,
        };
        self.$call.GetTableUserGroupManagement(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.searchTotalTable = dataResponse.data.total;
              self.userList = dataResponse.data.data;
              self.totalTable = dataResponse.data.total;
            } else {
              self.userList = [];
              self.totalTable = 0;
              self.searchTotalTable = 0;
            }
            self.dialog = false;
            self.loadingTable = false;
            self.isSearch = false;
            self.isFirst = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.loadingTable = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.dialog = false;
        this.loadingTable = false;
        this.LogTrace(error, "Get");
      }
    },
    async AutoRefresh() {
      let self = this;
      let death_waiting = true;
      // self.StatusSync = true;
      do {
        for (let value of self.userList) {
          if (value.inProcess < value.inProcessMax && !value.isError) {
            self.ReFreshGet();
            self.StatusSync = true;
            death_waiting = true;
            break;
          } else {
            death_waiting = false;
            self.StatusSync = false;
          }
        }
        if (window.location.pathname != "/UserGroupDetail") {
          death_waiting = false;
        }
        console.log("Wait for 5 seconds!");
        await new Promise((resolve) => setTimeout(resolve, 5000));
      } while (death_waiting);
    },
    EditUser(temp) {
      let self = this;
      //self.oldPassword = self.decryptShiftData(temp.password, 7);
      self.Editdialog = true;
      self.edit.id = temp.userId;
      self.edit.username = temp.username;
      self.edit.firstname = temp.firstName;
      self.edit.lastname = temp.lastName;
      // self.edit.password = temp.password;
      // self.edit.password = self.decryptShiftData(temp.password, 7);
      // self.edit.employeename = temp.employeeName;
      self.edit.roleId =
        temp.roleId == null || temp.roleId == undefined ? 2 : temp.roleId;
      self.edit.userType = temp.userType;
      self.edit.email = temp.email;
      self.edit.phone = temp.mobile;
      self.edit.modelQuickGroupID = temp.modelQuickGroupID;
      self.edit.socialUserID = temp.socialUserID;
      self.edit.recipientID = temp.recipientID;
      self.edit.recipientId_Instagram = temp.recipientId_Instagram;
      self.edit.isUserFromLine = temp.isUserFromLine;
      if (temp.groupModel == null) {
        self.edit.groupModel = null;
      } else {
        self.edit.groupModel = parseInt(temp.groupModel);
      }
      if (temp.model == null) {
        self.edit.model = [];
      } else {
        self.edit.model = temp.model;
      }
    },
    UpdateUser() {
      try {
        let self = this;
        self.dialog = true;
        let emailvali = self.validateEmail(self.edit.email);
        if (
          self.edit.username != "" &&
          self.edit.lastname != "" &&
          self.edit.firstname != "" &&
          self.edit.email != "" &&
          self.edit.password != "" &&
          (self.edit.groupModel != null || self.edit.model.length != 0) &&
          emailvali
        ) {
          let tempUser = {
            userId: self.edit.id,
            username: self.edit.username,
            password: self.edit.password,
            idcard: 0,
            prefixId: 0,
            firstName: self.edit.firstname,
            lastName: self.edit.lastname,
            roleId: self.edit.roleId,
            mobile: self.edit.phone,
            eMail: self.edit.email,
            groupModel: self.edit.groupModel,
            model: self.edit.model,
            modelQuickGroupID: self.edit.modelQuickGroupID,
            socialUserID: self.edit.socialUserID,
            recipientID: self.edit.recipientID,
            recipientId_Instagram: self.edit.recipientId_Instagram,
          };
          self.$call.UpdateUserChat(
            tempUser,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                if (Cookies.get("userId") == self.edit.id) {
                  Cookies.set(
                    "fullName",
                    `${self.edit.firstname} ${self.edit.lastname}`
                  );
                  store.state.fullName = `${self.edit.firstname} ${self.edit.lastname}`;
                  Cookies.set("username", self.edit.username);
                  if (self.oldPassword != self.edit.password) {
                    self.$call.ClearUserInfo();
                    self.$router.push("/login");
                  }
                }
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Editdialog = false;
                self.edit.name = null;
                self.edit.surname = null;
                self.edit.email = null;
                self.edit.department = null;
                self.edit.section = null;
                self.edit.status = null;
                self.edit.roleId = null;
                self.edit.userType = null;
                self.edit.model = null;

                self.Get();
              } else {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              console.error(errorResource);
            }
          );
        } else {
          if (emailvali != true /*|| phonevali != true*/) {
            self.$swal.fire({
              icon: "warning",
              title: "please fill correct format!",
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.edit.username == "" ||
            self.edit.firstname == "" ||
            self.edit.lastname == "" ||
            self.edit.roleId == "" ||
            self.edit.userType == "" ||
            self.edit.groupModel == null ||
            self.edit.model.length < 1
          ) {
            self.$swal.fire({
              icon: "warning",
              title: "please fill all fields!!!",
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (self.user.roleId == null) {
            self.$swal.fire({
              icon: "warning",
              title: "Please fill correct format!",
              showConfirmButton: false,
              timer: 2000,
            });
          }
          self.formHasErrors = true;
          self.Editdialog = true;
          self.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "UpdateUser");
      }
    },
    DeleteUser(user) {
      let self = this;
      let id = user.userId;
      let groupID = self.groupID;
      try {
        if (user.roleId == 0 && self.roleId != "0") {
          self.$swal.fire({
            icon: "warning",
            title: this.$t("notAuthoritySuperAdmin"),
            showConfirmButton: false,
            timer: 2000,
          });
          return;
        }
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            text: this.$t("confirmDeletionUser"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              let temp = {
                id: id,
                groupid: groupID,
              };
              self.$call.DeleteUserByID(
                temp,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.totalTable = self.totalTable - 1;
                    self.Get();
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  } else if (dataResponse.status == 4) {
                    self.$swal.fire({
                      icon: "warning",
                      title: this.$t("oneSuperAdmin"),
                      showConfirmButton: false,
                      timer: 2000,
                    });
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteUser");
      }
    },
    decryptData(encryptedText, key) {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedText, key);
      const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
      return decryptedText;
    },
    decryptShiftData(encryptedText, shift) {
      let chars = encryptedText.split("");
      let decryptedChars = [];

      for (let i = 0; i < chars.length; i++) {
        let c = chars[i];

        if (/[a-zA-Z]/.test(c)) {
          let offset =
            c === c.toUpperCase() ? "A".charCodeAt(0) : "a".charCodeAt(0);
          c = String.fromCharCode(
            ((c.charCodeAt(0) - offset - shift + 26) % 26) + offset
          );
        } else if (/[0-9]/.test(c)) {
          c = String.fromCharCode(
            ((c.charCodeAt(0) - "0".charCodeAt(0) - shift + 10) % 10) +
              "0".charCodeAt(0)
          );
        }

        decryptedChars.push(c);
      }

      return decryptedChars.join("");
    },
    closeChangePassword() {
      let self = this;
      self.edit.password = null;
      self.edit.confirmpassword = null;
      self.checkLengthPassword = true;
      self.checkLowercaseLetter = true;
      self.checkUppercaseLetter = true;
      self.checkNumber = true;
      self.checkSpecialCharacter = true;
      self.checkPasswordMatch = true;
      self.changePasswordDialog = false;
      self.show1 = false;
      self.show2 = false;
    },
    saveChangePassword() {
      try {
        let self = this;
        self.dialog = true;
        if (
          self.edit.password != "" &&
          self.edit.confirmpassword != "" &&
          self.edit.password != null &&
          self.edit.confirmpassword != null &&
          self.edit.password != undefined &&
          self.edit.confirmpassword != undefined &&
          self.edit.password == self.edit.confirmpassword &&
          self.checkPasswordMatch == true &&
          self.checkLengthPassword &&
          self.checkLowercaseLetter &&
          self.checkUppercaseLetter &&
          self.checkNumber &&
          self.checkSpecialCharacter
        ) {
          let temp = {
            userID: self.edit.id,
            password: self.edit.password,
          };
          self.$call.SaveChangePasswordUserChat(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.edit.password = null;
                self.edit.confirmpassword = null;
                self.checkLengthPassword = true;
                self.checkLowercaseLetter = true;
                self.checkUppercaseLetter = true;
                self.checkNumber = true;
                self.checkSpecialCharacter = true;
                self.checkPasswordMatch = true;
                self.changePasswordDialog = false;
                self.show1 = false;
                self.show2 = false;
              } else {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              console.error(errorResource);
            }
          );
        } else {
          if (self.edit.password != null && self.edit.confirmpassword == null) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Confirm Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.edit.password == null &&
            self.edit.confirmpassword != null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.edit.password == null &&
            self.edit.confirmpassword == null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Password and Confirm Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            !self.checkLengthPassword ||
            !self.checkLowercaseLetter ||
            !self.checkUppercaseLetter ||
            !self.checkNumber ||
            !self.checkSpecialCharacter
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill correct format!"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.edit.password != self.edit.confirmpassword &&
            self.checkPasswordMatch == false
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t(
                "Password and Confirm Password do not match.Please fill correctly."
              ),
              showConfirmButton: false,
              timer: 2000,
            });
          } else {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill all the fields!!!"),
              showConfirmButton: false,
              timer: 2000,
            });
          }
          self.changePasswordDialog = true;
          self.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "saveChangePassword");
      }
    },
  },
};
</script>
<style scoped>
/* Base Styles */
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

.title {
  color: white;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.pass {
  display: none;
}

.failed {
  display: block;
  color: red;
}

/* Search Panel */
.search-panel {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px !important;
  transition: all 0.3s ease;
  overflow: hidden;
}

.search-panel:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: rgba(25, 118, 210, 0.2);
}

/* Action Controls */
.action-controls {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 12px;
  padding: 4px 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
  min-width: 300px;
}

.action-controls:hover {
  background: rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.control-btn {
  margin: 0 4px;
  font-weight: 500;
  letter-spacing: 0.025em;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.sync-btn,
.setup-btn {
  width: 120px;
  height: 36px;
}

.sync-btn:hover:not(:disabled) {
  background: transparent !important;
  box-shadow: none;
  transform: translate(0);
}

.setup-btn {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%) !important;
  color: white !important;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3) !important;
}

.setup-btn:hover {
  background: linear-gradient(135deg, #388e3c 0%, #2e7d32 100%) !important;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4) !important;
  transform: translateY(-1px);
}

.btn-text {
  font-size: 0.875rem;
  font-weight: 500;
}

/* Data Table Styles */
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

/* Action Buttons in Table */
.action-group {
  display: flex;
  align-items: center;
  gap: 4px;
}

.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 4px;
}

/* No Data Template */
.no-data-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  padding: 40px 20px;
}

.no-data-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 400px;
  gap: 24px;
}

.no-data-icon {
  opacity: 0.6;
  transition: opacity 0.3s ease;
}

.no-data-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.no-data-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #424242;
  margin: 0;
  letter-spacing: 0.025em;
}

.no-data-subtitle {
  font-size: 0.9rem;
  color: #757575;
  margin: 0;
  font-weight: 400;
  line-height: 1.4;
}

.no-data-btn {
  border-radius: 8px !important;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.025em;
  min-width: 140px;
  height: 40px;
}

.no-data-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
}

/* Dialog Styles */
.edit-user-dialog,
.change-password-dialog {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  animation: slideInDown 0.3s ease-out;
}

.edit-user-header,
.change-password-header {
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.edit-user-header {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
}

.change-password-header {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  font-size: 28px;
  opacity: 0.9;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
  color: white;
}

.dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.8;
  margin: 0;
  line-height: 1.3;
  color: white;
}

.close-btn {
  color: rgba(255, 255, 255, 0.8) !important;
  transition: all 0.2s ease;
}

.close-btn:hover {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.edit-user-content,
.change-password-content {
  padding: 24px;
  background-color: #fafafa;
  max-height: 70vh;
  overflow-y: auto;
}

/* Form Sections */
.form-section {
  margin-bottom: 24px;
  transition: all 0.3s ease;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid rgba(var(--v-theme-primary), 0.1);
}

.section-divider {
  margin: 20px 0;
  opacity: 0.6;
}

.form-row {
  margin-bottom: 8px;
}

.form-row .v-col {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* Input Styling */
.input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  min-height: 60px;
}

.input-wrapper:has(.password-requirements) {
  min-height: 200px;
}

.input-wrapper:has(.password-match) {
  min-height: 120px;
}

.input-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  opacity: 0.87;
  line-height: 1.2;
}

.modern-input :deep(.v-field) {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.modern-input :deep(.v-field--focused) {
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.15);
}

.modern-input :deep(.v-field__outline) {
  --v-field-border-opacity: 0.25;
}

.modern-input :deep(.v-field--focused .v-field__outline) {
  --v-field-border-opacity: 1;
  --v-field-border-width: 2px;
}

.change-password-content .modern-input :deep(.v-field--focused) {
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.15);
}

.change-password-content
  .modern-input
  :deep(.v-field--focused .v-field__outline) {
  border-color: #ff9800;
}

.help-icon {
  color: rgba(var(--v-theme-primary), 0.7);
  cursor: help;
  transition: color 0.2s ease;
}

.help-icon:hover {
  color: rgb(var(--v-theme-primary));
}

/* Password Requirements */
.password-requirements,
.password-match {
  margin-top: 8px;
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.password-requirements {
  padding: 12px;
  overflow: hidden;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.password-match {
  padding: 8px 12px;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.requirement-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8rem;
  margin: 4px 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 4px 6px;
  border-radius: 6px;
  opacity: 0;
  transform: translateX(-10px);
  animation: slideInRequirement 0.4s ease-out forwards;
}

.requirement-item:nth-child(1) {
  animation-delay: 0.1s;
}
.requirement-item:nth-child(2) {
  animation-delay: 0.15s;
}
.requirement-item:nth-child(3) {
  animation-delay: 0.2s;
}
.requirement-item:nth-child(4) {
  animation-delay: 0.25s;
}
.requirement-item:nth-child(5) {
  animation-delay: 0.3s;
}

.requirement-item.valid {
  color: rgb(var(--v-theme-success));
  background: rgba(var(--v-theme-success), 0.08);
  border-left: 3px solid rgb(var(--v-theme-success));
}

.requirement-item:not(.valid) {
  color: rgb(var(--v-theme-error));
  background: rgba(var(--v-theme-error), 0.08);
  border-left: 3px solid rgb(var(--v-theme-error));
}

/* Security Tips */
.security-tips {
  margin-top: 20px;
  animation: fadeInUp 0.5s ease-out 0.3s both;
}

.security-alert {
  border-radius: 12px;
  border: 1px solid rgba(var(--v-theme-info), 0.2);
  overflow: hidden;
  transition: all 0.3s ease;
}

.security-alert:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(var(--v-theme-info), 0.15);
}

.alert-content {
  font-size: 0.875rem;
}

.tips-list {
  margin: 8px 0 0 16px;
  padding: 0;
}

.tips-list li {
  margin: 4px 0;
  line-height: 1.4;
  color: rgba(var(--v-theme-on-surface), 0.8);
  opacity: 0;
  transform: translateX(-10px);
  animation: slideInTip 0.4s ease-out forwards;
}

.tips-list li:nth-child(1) {
  animation-delay: 0.9s;
}
.tips-list li:nth-child(2) {
  animation-delay: 1s;
}
.tips-list li:nth-child(3) {
  animation-delay: 1.1s;
}
.tips-list li:nth-child(4) {
  animation-delay: 1.2s;
}

/* Action Buttons */
.edit-user-actions,
.change-password-actions {
  background-color: #f8f9fa;
  padding: 16px 24px;
  gap: 12px;
}

.edit-user-actions {
  display: flex;
  align-items: center;
}

/* .dialog-action-btn, */
.cancel-btn,
.save-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  height: 44px;
  min-width: 120px;
  transition: all 0.2s ease;
}

/* .dialog-action-btn {
  padding: 0 20px;
  height: 40px;
  min-width: 140px;
} */

.cancel-btn,
.save-btn {
  padding: 0 24px;
}

.cancel-btn:hover {
  background-color: rgba(var(--v-theme-surface), 0.8);
  transform: translateY(-1px);
}

/* .dialog-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);
} */

.save-btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

.edit-user-actions .save-btn {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
}

.edit-user-actions .save-btn:hover {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);
}

.change-password-actions .save-btn {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
}

.change-password-actions .save-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #f57c00 0%, #ef6c00 100%);
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.4);
}

.change-password-actions .save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* Animations */
.mdi-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRequirement {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInTip {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Vue Transitions */
.expand-fade-enter-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.expand-fade-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.expand-fade-enter-from {
  opacity: 0;
  transform: translateY(-15px) scaleY(0.8);
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
}

.expand-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px) scaleY(0.9);
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
}

.expand-fade-enter-to,
.expand-fade-leave-from {
  opacity: 1;
  transform: translateY(0) scaleY(1);
  max-height: 200px;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-top: 8px;
}

/* Dark Theme Support */
.v-theme--dark .search-panel {
  background: linear-gradient(135deg, #2d2d2d 0%, #1e1e1e 100%);
  border-color: rgba(255, 255, 255, 0.12);
}

.v-theme--dark .action-controls {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.12);
}

.v-theme--dark .action-controls:hover {
  background: rgba(255, 255, 255, 0.08);
}

.v-theme--dark .no-data-title {
  color: #e0e0e0;
}

.v-theme--dark .no-data-subtitle {
  color: #bdbdbd;
}

.v-theme--dark .action-divider {
  background: rgba(255, 255, 255, 0.2);
}

/* Responsive Design */
@media (max-width: 768px) {
  .action-controls {
    min-width: auto;
    width: 100%;
    justify-content: space-around;
    padding: 8px 12px;
  }

  .sync-btn,
  .setup-btn {
    width: auto;
    min-width: 100px;
    flex: 1;
  }

  .no-data-container {
    min-height: 250px;
    padding: 30px 16px;
  }

  .no-data-content {
    gap: 20px;
  }

  .no-data-icon {
    font-size: 56px !important;
  }

  .no-data-title {
    font-size: 1.1rem;
  }

  .no-data-subtitle {
    font-size: 0.85rem;
  }

  .no-data-btn {
    width: 100%;
    max-width: 200px;
  }

  .edit-user-dialog,
  .change-password-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px) !important;
  }

  .edit-user-header,
  .change-password-header {
    padding: 16px 20px;
  }

  .edit-user-content,
  .change-password-content {
    padding: 16px;
    max-height: 60vh;
  }

  .edit-user-actions {
    flex-direction: column;
    gap: 8px;
  }

  /* .dialog-action-btn {
    width: 100%;
    order: 1;
  } */

  .cancel-btn {
    width: 100%;
    order: 2;
  }

  .save-btn {
    width: 100%;
    order: 3;
  }
}

@media (max-width: 480px) {
  .action-controls {
    flex-direction: column;
    gap: 8px;
    padding: 12px;
  }

  .sync-btn,
  .setup-btn {
    width: 100%;
  }

  .action-group {
    gap: 8px;
  }

  .edit-user-dialog,
  .change-password-dialog {
    margin: 8px;
    max-width: calc(100vw - 16px) !important;
  }

  .change-password-actions {
    flex-direction: column;
    gap: 8px;
  }

  .cancel-btn,
  .save-btn {
    width: 100%;
  }
}
</style>
